import React, { Component } from "react";
import "./TabPanel.scss";

export default class TabPanel extends Component {
    render() {
        return (
            <div
                id={this.props.idKey}
                className={
                    "justify-content-around justify-content-lg-start mt-3 tab-pane fade" +
                    (this.props.active ? " active show" : "")
                }
            >
                {this.props.children}
            </div>
        );
    }
}
